import styled, { useTheme } from 'styled-components/native';

import IconNewLike from '../../assets/svg/IconNewLike';
import LinearGradient from '../../elements/LinearGradient';
import { translate } from '../../i18n';
import { BtnContentProps } from '../VendorItem/types';

export default function CollectBtnContent({
  isCollected,
  isOffline,
}: BtnContentProps) {
  const { palette } = useTheme();
  const { veryBuyPink, coral, white } = palette;

  switch (true) {
    case !isOffline && isCollected: {
      return (
        <S.DefaultContainer>
          <S.DefaultText>{translate('already-collection')}</S.DefaultText>
        </S.DefaultContainer>
      );
    }
    case !isOffline && !isCollected: {
      return (
        <S.CollectContainer
          colors={[veryBuyPink, coral]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 0 }}
        >
          <IconNewLike size={15} fillColor={white} />
          <S.CollectText>{translate('collection')}</S.CollectText>
        </S.CollectContainer>
      );
    }
    default: {
      return null;
    }
  }
}

const S = {
  DefaultContainer: styled.View`
    border-color: ${({ theme }) => theme.palette.coral};
    border-radius: 3px;
    border-width: 1px;
    padding: 3px 10px;
  `,
  CollectContainer: styled(LinearGradient)`
    align-items: center;
    border-radius: 3px;
    flex-direction: row;
    justify-content: center;
    padding: 4px 10px;
  `,
  CollectText: styled.Text`
    color: ${({ theme }) => theme.palette.white};
    font-size: 13px;
    margin-left: 4px;
  `,
  DefaultText: styled.Text`
    color: ${({ theme }) => theme.palette.coral};
    font-size: 13px;
  `,
};
